import { Button } from "@components/controls/Button"
import { IconAdd } from "@components/svg/Icons"
import { CustomBlockAppender, defineBlock, EditableText, InnerBlocks, usePostTitleEditor } from "eddev/blocks"
import { twMerge } from "tailwind-merge"

export const meta: BlockMeta = {
  title: "FAQ Group",
  tags: ["root"],
  conditions: {
    postTypes: ["faq"],
  },
}

const Appender: CustomBlockAppender = (props) => {
  return (
    <div className="flex p-2 gap-2 justify-end">
      <Button leftIcon={<IconAdd />} {...props}>
        Add Question
      </Button>
    </div>
  )
}

export default defineBlock("faq/faq-group", (props) => {
  return (
    <div className={twMerge("[&_.block-list-appender]:!relative")}>
      <EditableText store="title" as="h2" placeholder="Enter a title" className="type-title-m-medium border-b border-black pb-3 mb-4" />
      <InnerBlocks allowedBlocks={["faq/faq-item"]} template={[["faq/faq-item", {}]]} appender={{ type: Appender }} />
    </div>
  )
})
